<template>
  <div>
    <section v-if="scrollingLiveEventsWidget === 'default'">
      <v-progress-linear
        indeterminate
        color="primary darken-2"
        v-if="getLoadingDetail"
      ></v-progress-linear>
      <div class="preview" v-if="!this.getLoadingLive">
        <hooper :settings="hooperSettings" style="height: 860px">
          <slide
            v-for="(object, index) in this.getPreviewLive"
            :key="$uuid.v1()"
            v-if="checkMatch(object)"
            style="height: auto; max-height: 450px"
          >
            <div class="card-live" style="min-width: 250px">
              <div
                class="card-header-live"
                @click="
                  getDetailOfEventLive(
                    object.events[0].id,
                    object.events[0].type,
                    object.sport.id,
                    object.tournament.id ? object.tournament.id : '',
                    object.events[0].status
                  )
                "
                :title="$t('seeDetail')"
              >
                <div class="competitors">
                  <span
                    class="team"
                    :title="object.events[0].competitors.home.name"
                    >{{ object.events[0].competitors.home.name }}</span
                  >
                  <span
                    class="team"
                    :title="object.events[0].competitors.away.name"
                    >{{ object.events[0].competitors.away.name }}</span
                  >
                  <span
                    class="info-tournament"
                    :title="object.category.name + ',' + object.tournament.name"
                    >{{ object.category.name }},
                    {{ object.tournament.name }}</span
                  >
                </div>
                <div class="info-match">
                  <span
                    class="time"
                    v-if="object.events[0].livescore.Scoreboard.Time != '-1'"
                    >{{
                      getMatchCurrentTime(
                        object.events[0].livescore.Scoreboard.Time
                      )
                    }}<span class="blink_me">'</span></span
                  >
                  <span class="result"
                    >{{
                      getResult(
                        object.events[0].livescore.Scoreboard.Results,
                        'home'
                      )
                    }}<span class="blink_me">:</span
                    >{{
                      getResult(
                        object.events[0].livescore.Scoreboard.Results,
                        'away'
                      )
                    }}</span
                  >
                  <span class="current-period">{{
                    getMatchCurrentPeriod(
                      object.events[0].livescore.Scoreboard.CurrentPeriod
                    )
                  }}</span>
                </div>
              </div>
              <div class="card-body-live">
                <div class="market">
                  <span class="line-divider"></span>
                  <span
                    class="market-name"
                    :title="object.events[0].odds[0].name_market"
                    >{{ object.events[0].odds[0].name_market }}</span
                  >
                  <span class="line-divider"></span>
                </div>
                <div class="odds-market">
                  <div class="odd" v-for="odd in object.events[0].odds[0].odds">
                    <div
                      v-if="odd.outcome_odd_value > 0 && odd.active"
                      :class="[
                        'value',
                        'multi-' + object.events[0].odds[0].multiplicity_min,
                        odd.type_change != undefined
                          ? 'odd_change_' + odd.type_change
                          : 'odd_change_equal',
                        getOddsSources.includes(odd.unique_id)
                          ? 'odd_selected'
                          : '',
                      ]"
                      @click="
                        putCart(
                          odd,
                          object.events[0],
                          object.sport,
                          object.category,
                          object.tournament
                        )
                      "
                    >
                      <span class="alias">{{
                        odd.outcome_alias || odd.outcome_name
                      }}</span>
                      <span
                        :class="[
                          odd.type_change != undefined
                            ? 'odd_value_' + odd.type_change
                            : 'odd_value_equal',
                          'value-odd',
                        ]"
                        >{{ odd.outcome_odd_value }}</span
                      >
                      <div
                        :class="[
                          odd.type_change != undefined
                            ? odd.type_change
                            : 'equal',
                        ]"
                      ></div>
                    </div>
                    <div
                      v-else
                      class="value"
                      :class="
                        'multi-' + object.events[0].odds[0].multiplicity_min
                      "
                    >
                      <v-icon dense>mdi-lock</v-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </slide>
        </hooper>
      </div>
    </section>
    <section v-if="scrollingLiveEventsWidget === 'enhanced-1'">
      <v-progress-linear
        indeterminate
        color="primary darken-2"
        v-if="getLoadingDetail"
      ></v-progress-linear>
      <div class="preview" v-if="!this.getLoadingLive">
        <div class="event-live-scroller-enhanced-container">
          <div
            class="event-live-scroller-enhanced-slide"
            v-for="(object, index) in this.getPreviewLive"
            :key="$uuid.v1()"
            v-if="checkMatch(object)"
            style="height: auto; max-height: 450px"
          >
            <div class="card-live" style="min-width: 250px">
              <div
                class="card-header-live"
                @click="
                  getDetailOfEventLive(
                    object.events[0].id,
                    object.events[0].type,
                    object.sport.id,
                    object.tournament.id ? object.tournament.id : '',
                    object.events[0].status
                  )
                "
                :title="$t('seeDetail')"
              >
                <div class="competitors">
                  <span
                    class="team"
                    :title="object.events[0].competitors.home.name"
                    >{{ object.events[0].competitors.home.name }}</span
                  >
                  <span
                    class="team"
                    :title="object.events[0].competitors.away.name"
                    >{{ object.events[0].competitors.away.name }}</span
                  >
                  <span
                    class="info-tournament"
                    :title="object.category.name + ',' + object.tournament.name"
                    >{{ object.category.name }},
                    {{ object.tournament.name }}</span
                  >
                </div>
                <div class="info-match">
                  <span
                    class="time"
                    v-if="object.events[0].livescore.Scoreboard.Time != '-1'"
                    >{{
                      getMatchCurrentTime(
                        object.events[0].livescore.Scoreboard.Time
                      )
                    }}<span class="blink_me">'</span></span
                  >
                  <span class="result"
                    >{{
                      getResult(
                        object.events[0].livescore.Scoreboard.Results,
                        'home'
                      )
                    }}<span class="blink_me">:</span
                    >{{
                      getResult(
                        object.events[0].livescore.Scoreboard.Results,
                        'away'
                      )
                    }}</span
                  >
                  <span class="current-period">{{
                    getMatchCurrentPeriod(
                      object.events[0].livescore.Scoreboard.CurrentPeriod
                    )
                  }}</span>
                </div>
              </div>
              <div class="card-body-live">
                <div class="market">
                  <span class="line-divider"></span>
                  <span
                    class="market-name"
                    :title="object.events[0].odds[0].name_market"
                    >{{ object.events[0].odds[0].name_market }}</span
                  >
                  <span class="line-divider"></span>
                </div>
                <div class="odds-market">
                  <div class="odd" v-for="odd in object.events[0].odds[0].odds">
                    <div
                      v-if="odd.outcome_odd_value > 0 && odd.active"
                      :class="[
                        'value',
                        'multi-' + object.events[0].odds[0].multiplicity_min,
                        odd.type_change != undefined
                          ? 'odd_change_' + odd.type_change
                          : 'odd_change_equal',
                        getOddsSources.includes(odd.unique_id)
                          ? 'odd_selected'
                          : '',
                      ]"
                      @click="
                        putCart(
                          odd,
                          object.events[0],
                          object.sport,
                          object.category,
                          object.tournament
                        )
                      "
                    >
                      <span class="alias">{{
                        odd.outcome_alias || odd.outcome_name
                      }}</span>
                      <span
                        :class="[
                          odd.type_change != undefined
                            ? 'odd_value_' + odd.type_change
                            : 'odd_value_equal',
                          'value-odd',
                        ]"
                        >{{ odd.outcome_odd_value }}</span
                      >
                      <div
                        :class="[
                          odd.type_change != undefined
                            ? odd.type_change
                            : 'equal',
                        ]"
                      ></div>
                    </div>
                    <div
                      v-else
                      class="value"
                      :class="
                        'multi-' + object.events[0].odds[0].multiplicity_min
                      "
                    >
                      <v-icon dense>mdi-lock</v-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import _ from 'lodash'
import { Hooper, Slide } from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: 'LiveEventsVerticalScroller',
  components: {
    Hooper,
    Slide,
  },
  data: () => ({
    hooperSettings: {
      itemsToShow: 6,
      centerMode: false,
      vertical: true,
      height: 200,
    },
    limit: 30,
    livesCount: [],
    loading: false,
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT + '/category-images/rectangular/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/sport-images/icons/',
    sportPath:
      'https://rocky-revenge.s3-eu-west-1.amazonaws.com/svg/sports/light/',
  }),
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getFilter: 'tree/getFilter',
      getPreviewLive: 'odds/getPreviewLive',
      getCountLive: 'odds/getCountLive',
      getEventsDetailActive: 'odds/getEventsDetailActive',
      getEventsLiveDetailActive: 'odds/getEventsLiveDetailActive',
      getLoadingPreview: 'odds/getLoadingPreview',
      getLoadingLive: 'odds/getLoadingLive',
      getLoadingDetail: 'odds/getLoadingDetail',
      getOddsSources: 'cart/getOddsSources',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
      getPlatformId: 'settings/getPlatformId',
      scrollingLiveEventsWidget: 'uiConfig/scrollingLiveEventsWidget',
    }),
  },
  methods: {
    ...mapActions({
      setFilter: 'tree/setFilter',
      removeFromPreview: 'odds/removeFromPreview',
      fetchEventDetail: 'odds/fetchEventDetail',
      fetchEventLiveDetail: 'odds/fetchEventLiveDetail',
      setLoadingPreview: 'odds/setLoadingPreview',
      setLoadingLive: 'odds/setLoadingLive',
      setLoadingDetail: 'odds/setLoadingDetail',
      addOddToCart: 'cart/addOddToCart',
      fetchLive: 'odds/fetchLive',
      setLiveMode: 'odds/setLiveMode',
      setEventStatscore: 'odds/setEventStatscore',
    }),
    async changeLive(sport) {
      await this.setLoadingLive({ status: true })
      await this.fetchLive({
        sport: sport.id,
        sport_id: sport._id,
        group: false,
      })
      await this.setLoadingLive({ status: false })
    },
    getTitle(item) {
      return _.find(item.detail, { lang: this.getLanguage }).text
    },
    groupByDate(events) {
      const refactored = _.groupBy(events, 'day')
      return refactored
    },
    increaseLimit() {
      this.limit = this.limit + this.offset
    },
    changeLiveMode(mode) {
      this.setLiveMode({ mode: mode })
    },
    getRandomInt(min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    async putCart(odd, event, sport, category, tournament) {
      if (parseFloat(odd.outcome_odd_value) > 0 && odd.active) {
        await this.addOddToCart({
          odd: odd,
          event: event,
          sport: sport,
          category: category,
          tournament: tournament,
        })
        this.$root.$emit('forceUpdateSingleMultiple')
        this.$root.$emit('forceUpdateIntegral')
        this.$root.$emit('forceUpdateSystem')
      }
    },
    async getDetailOfEventLive(eventSource, type, sport, tournament, status) {
      await this.setLoadingDetail({ status: true })
      await this.fetchEventLiveDetail({
        source: eventSource,
        group: 0,
        sport: sport,
        tournament: tournament,
        status: status,
      })
      await this.setLoadingDetail({ status: false })
      await this.$root.$emit('reloadStatscore')
      await this.$root.$emit('resetTabLiveEventDetailMarketGroup')
    },

    getMatchCurrentTime(time) {
      if (time >= 0) {
        const minutes = Math.floor(time / 60)
        return minutes
      } else {
        return 0
      }
    },
    getResult(result, team) {
      if (team == 'home') {
        var point = _.find(result, { Position: '1' })
        return point ? +point.Value : 0
      } else if (team == 'away') {
        var point = _.find(result, { Position: '2' })
        return point ? +point.Value : 0
      } else {
        return 0
      }
    },
    getMatchCurrentPeriod(period) {
      let find = _.find(period, { lang: this.getLanguage })
      if (find) {
        return find.text
      } else {
        find = _.find(period, { lang: 'en' })
        if (find) {
          return find.text
        } else {
          return ''
        }
      }
    },
    checkMatch(event) {
      const status = event.events[0].livescore.Scoreboard.Status
      const detail = this.getEventsLiveDetailActive[0]
        ? this.getEventsLiveDetailActive[0]
        : 'ok'
      if (status == 2 && (detail == 'ok' || detail != event.events[0].id)) {
        return true
      } else {
        return false
      }
    },
  },
  async mounted() {
    await this.setLoadingLive({ status: true })
    await this.fetchLive({ group: false })
    await this.setLoadingLive({ status: false })
  },
}
</script>
<style></style>
